var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    stroke: "white",
    fill: "white",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v233.7h233.7V0H0zm200.3 200.3h-167v-167h167v167z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8 66.8H167V167H66.8zM278.3 0v233.7H512V0H278.3zm200.3 200.3h-167v-167h167v167z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M345 66.8h100.2V167H345zM0 278.3V512h233.7V278.3H0zm200.3 200.3h-167v-167h167v167z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8 345H167v100.2H66.8zM345 311.7v-33.4h-66.7V512H345v-33.4h-33.3v-66.8H345v-33.4h-33.3v-66.7zM478.6 278.3H512v33.4h-33.4zM478.6 356.2v122.4h-33.4V512H512V356.2zM378.4 278.3h66.8v33.4h-66.8zM445.2 378.4V345h-66.8v100.2h66.8v-33.4h-33.4v-33.4zM378.4 478.6h33.4V512h-33.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.ada0288cb9f2839be39a1d3c08f0621d.svg";
export { ForwardRef as ReactComponent };